import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';

const CHECK_INTERVAL = 30000; // Verificar a cada 30 segundos

export function useVersionCheck() {
  const currentVersion = useRef(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Adicionar timestamp para evitar cache
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store'
        });
        
        if (!response.ok) return;
        
        const data = await response.json();
        
        if (currentVersion.current === null) {
          // Primeira verificação - salvar versão atual
          currentVersion.current = data.version;
        } else if (currentVersion.current !== data.version) {
          // Nova versão detectada!
          setUpdateAvailable(true);
          showUpdateToast();
        }
      } catch (error) {
        // Silenciar erros de rede
      }
    };

    // Verificar imediatamente
    checkVersion();
    
    // Verificar periodicamente
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    
    return () => clearInterval(interval);
  }, []);

  const showUpdateToast = () => {
    toast.custom(
      (t) => (
        <div className="flex items-center gap-3 bg-gradient-to-r from-emerald-500/20 to-cyan-500/20 border border-emerald-500/50 rounded-lg p-4 shadow-lg backdrop-blur-sm">
          <div className="flex-shrink-0">
            <RefreshCw className="h-5 w-5 text-emerald-400 animate-spin" />
          </div>
          <div className="flex-1">
            <p className="font-medium text-white">Nova versão disponível!</p>
            <p className="text-sm text-gray-300">Clique para atualizar o sistema</p>
          </div>
          <button
            onClick={() => {
              toast.dismiss(t);
              window.location.reload();
            }}
            className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-medium rounded-md transition-colors"
          >
            Atualizar
          </button>
        </div>
      ),
      {
        duration: Infinity,
        position: 'bottom-right',
        id: 'update-available'
      }
    );
  };

  const reloadApp = () => {
    window.location.reload();
  };

  return { updateAvailable, reloadApp };
}

export default useVersionCheck;
